/* eslint-disable max-len */
/**
 * French translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {},
  LABEL: {
    CODE: 'Code',
    COUNTERPARTS: 'Contreparties',
    CURRENT: 'Actuel',
    GENERAL_INFORMATION: 'Informations générales',
    MANAGER: 'Gestionnaire',
    PREVIOUS: 'Précédent',
    PRODUCTS: 'Produits',
    REMUNERATION: 'Rémunérations',
    SUPERVISOR: 'Superviseur'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
